import { Commission } from '../types/commission'

export const MOCK_COMMISSIONS: Commission[] = [
  {
    userId: 'u1',
    userName: 'Katrina Bullock',
    userProfile: 'Loan Officer',
    payPeriod: 'January 2026',
    units: 3,
    total: 4950.0,
    loans: [
      {
        loanId: 'LN-2026-001',
        amount: 350000,
        tier: 4,
        commission: 1750.0,
        date: '2026-01-05',
        leadSource: 'Zillow',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2026-002',
        amount: 280000,
        tier: 4,
        commission: 1400.0,
        date: '2026-01-12',
        leadSource: 'Realtor Referral',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2026-003',
        amount: 410000,
        tier: 4,
        commission: 1800.0,
        date: '2026-01-20',
        leadSource: 'Past Client',
        approvalStatus: 'pending',
      },
    ],
    profile: {
      badge: 'Gold',
      tenureDays: 45,
      lifetimeFundedVolume: 2500000,
    },
    review: {
      commissionId: 'u1',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
  {
    userId: 'u2',
    userName: 'Lucas Rohr',
    userProfile: 'Sales Team Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 3100.0,
    loans: [
      {
        loanId: 'LN-2025-004',
        amount: 550000,
        tier: 5,
        commission: 2100.0,
        date: '2025-12-02',
        leadSource: 'Builder',
        approvalStatus: 'approved',
      },
      {
        loanId: 'LN-2025-005',
        amount: 220000,
        tier: 5,
        commission: 1000.0,
        date: '2025-12-15',
        leadSource: 'Website',
        approvalStatus: 'approved',
      },
    ],
    profile: {
      badge: 'Platinum',
      tenureDays: 120,
      lifetimeFundedVolume: 4500000,
    },
    review: {
      commissionId: 'u2',
      status: 'approved',
      flaggedLoans: [],
      comments: [],
      approvedAt: '2025-12-28',
      approvedBy: 'Lucas Rohr',
    },
  },
  {
    userId: 'u3',
    userName: 'Bianca Payton',
    userProfile: 'Division Leader',
    payPeriod: 'December 2025',
    units: 1,
    total: 1800.0,
    loans: [
      {
        loanId: 'LN-2025-006',
        amount: 480000,
        tier: 5,
        commission: 1800.0,
        date: '2025-12-10',
        leadSource: 'Bank Referral',
        approvalStatus: 'approved',
      },
    ],
    profile: {
      badge: 'Diamond',
      tenureDays: 450,
      lifetimeFundedVolume: 18000000,
    },
    review: {
      commissionId: 'u3',
      status: 'approved',
      flaggedLoans: [],
      comments: [],
      approvedAt: '2025-12-27',
      approvedBy: 'Bianca Payton',
    },
  },
  {
    userId: 'u4',
    userName: 'Antonio Hayes',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 0,
    total: 0.0,
    loans: [],
    profile: {
      badge: 'Gold',
      tenureDays: 30,
      lifetimeFundedVolume: 800000,
    },
    review: {
      commissionId: 'u4',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
  {
    userId: 'u5',
    userName: 'Melanie Rayis',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 8,
    total: 10800.0,
    loans: [
      {
        loanId: 'LN-2025-007',
        amount: 300000,
        tier: 3,
        commission: 1050.0,
        date: '2025-12-01',
        leadSource: 'Zillow',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-008',
        amount: 320000,
        tier: 3,
        commission: 1120.0,
        date: '2025-12-03',
        leadSource: 'Social Media',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-009',
        amount: 450000,
        tier: 3,
        commission: 1575.0,
        date: '2025-12-08',
        leadSource: 'Realtor Referral',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-010',
        amount: 280000,
        tier: 3,
        commission: 980.0,
        date: '2025-12-11',
        leadSource: 'Open House',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-011',
        amount: 390000,
        tier: 3,
        commission: 1365.0,
        date: '2025-12-15',
        leadSource: 'Past Client',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-012',
        amount: 510000,
        tier: 3,
        commission: 1785.0,
        date: '2025-12-18',
        leadSource: 'Builder',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-013',
        amount: 250000,
        tier: 3,
        commission: 875.0,
        date: '2025-12-22',
        leadSource: 'Website',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-014',
        amount: 550000,
        tier: 3,
        commission: 2050.0,
        date: '2025-12-28',
        leadSource: 'Bank Referral',
        approvalStatus: 'pending',
      },
    ],
    profile: {
      badge: 'Platinum',
      tenureDays: 150,
      lifetimeFundedVolume: 5200000,
    },
    review: {
      commissionId: 'u5',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
  {
    userId: 'u6',
    userName: 'Zaid Shuwayhat',
    userProfile: 'Sales Team Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 2800.0,
    loans: [
      {
        loanId: 'LN-2025-015',
        amount: 300000,
        tier: 5,
        commission: 1400.0,
        date: '2025-12-05',
        leadSource: 'Realtor Referral',
        approvalStatus: 'approved',
      },
      {
        loanId: 'LN-2025-016',
        amount: 300000,
        tier: 5,
        commission: 1400.0,
        date: '2025-12-20',
        leadSource: 'Zillow',
        approvalStatus: 'approved',
      },
    ],
    profile: {
      badge: 'Platinum',
      tenureDays: 180,
      lifetimeFundedVolume: 6000000,
    },
    review: {
      commissionId: 'u6',
      status: 'approved',
      flaggedLoans: [],
      comments: [],
      approvedAt: '2025-12-29',
      approvedBy: 'Zaid Shuwayhat',
    },
  },
  {
    userId: 'u7',
    userName: 'Daniel McCarthy',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 3,
    total: 4200.0,
    loans: [
      {
        loanId: 'LN-2025-017',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-04',
        leadSource: 'Social Media',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-018',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-14',
        leadSource: 'Open House',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-019',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-24',
        leadSource: 'Past Client',
        approvalStatus: 'pending',
      },
    ],
    profile: {
      badge: 'Gold',
      tenureDays: 60,
      lifetimeFundedVolume: 2000000,
    },
    review: {
      commissionId: 'u7',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
  {
    userId: 'u8',
    userName: 'Mike Kounini',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 0,
    total: 0.0,
    loans: [],
    profile: {
      badge: 'Gold',
      tenureDays: 15,
      lifetimeFundedVolume: 500000,
    },
    review: {
      commissionId: 'u8',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
  {
    userId: 'u9',
    userName: 'LaMonte Stinnette',
    userProfile: 'Division Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 4500.0,
    loans: [
      {
        loanId: 'LN-2025-020',
        amount: 600000,
        tier: 5,
        commission: 2500.0,
        date: '2025-12-10',
        leadSource: 'Builder',
        approvalStatus: 'approved',
      },
      {
        loanId: 'LN-2025-021',
        amount: 500000,
        tier: 5,
        commission: 2000.0,
        date: '2025-12-25',
        leadSource: 'Bank Referral',
        approvalStatus: 'approved',
      },
    ],
    profile: {
      badge: 'Diamond',
      tenureDays: 500,
      lifetimeFundedVolume: 20000000,
    },
    review: {
      commissionId: 'u9',
      status: 'approved',
      flaggedLoans: [],
      comments: [],
      approvedAt: '2025-12-26',
      approvedBy: 'LaMonte Stinnette',
    },
  },
  {
    userId: 'u10',
    userName: 'Charles Ryle',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 3,
    total: 3600.0,
    loans: [
      {
        loanId: 'LN-2025-022',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-02',
        leadSource: 'Website',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-023',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-12',
        leadSource: 'Zillow',
        approvalStatus: 'pending',
      },
      {
        loanId: 'LN-2025-024',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-22',
        leadSource: 'Realtor Referral',
        approvalStatus: 'pending',
      },
    ],
    profile: {
      badge: 'Gold',
      tenureDays: 75,
      lifetimeFundedVolume: 2500000,
    },
    review: {
      commissionId: 'u10',
      status: 'pending',
      flaggedLoans: [],
      comments: [],
    },
  },
]
